import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import TechPartnerSection from '../Components/transforming/TechPartnerSection'
import IndustriesShowcaseSlider from '../Components/transforming/IndustriesShowcaseSlider'
import WhyChooseMobikode from '../Components/transforming/WhyChooseMobikode'
import OurServicesSection from '../Components/transforming/OurServicesSection'
import OurValuesSection from '../Components/transforming/OurValuesSection'
import ContactSection from '../Components/transforming/ContactSection'
import OurIndustriesSection from '../Components/transforming/OurIndustriesSection'
import OurProductsSection from '../Components/transforming/OurProductsSection'
import OurAchievementsSection from '../Components/transforming/OurAchievementsSection'
import EngagementModal from '../Components/transforming/EngagementModal'
import CareerCTASection from '../Components/transforming/CareerCTASection'
import { Helmet } from "react-helmet-async";

function Transforming() {
    return (
        <div>
            <Helmet>
    <title>
        About Mobikode | Enterprise AI & ServiceNow Consulting & Technology Solutions
    </title>

    <meta
        name="description"
        content="Discover Mobikode, a technology partner helping businesses transform ideas into powerful digital solutions through custom software development, Enterprise AI & ServiceNow Consulting, innovative technology, and exceptional digital experiences."
    />

    <meta
        name="keywords"
        content="About Mobikode, Mobikode, Enterprise AI & ServiceNow Consulting Company, Technology Solutions Company, Software Development Company, Custom Software Development, Digital Solutions, IT Consulting Services, Enterprise Technology Solutions, Digital Innovation, Software Engineering, Technology Partner, Enterprise AI & ServiceNow Consulting Services"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/who-we-are"
    />

    <meta
        property="og:title"
        content="About Mobikode | Enterprise AI & ServiceNow Consulting & Technology Solutions"
    />

    <meta
        property="og:description"
        content="Learn about Mobikode and how we help businesses innovate, scale, and succeed through custom software development, Enterprise AI & ServiceNow Consulting, and technology solutions."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/who-we-are"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/transforming/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="About Mobikode | Enterprise AI & ServiceNow Consulting & Technology Solutions"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's approach to Enterprise AI & ServiceNow Consulting, custom software development, technology innovation, and creating powerful digital experiences for businesses."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/transforming/bg1.png"
    />
</Helmet>
            <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                {/* Background Image & Gradient Overlays */}
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/transforming/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                {/* Content Container */}
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Transforming Ideas into Powerful Digital Solutions
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            We help businesses innovate, scale, and succeed through cutting-edge technology solutions, custom software development, and exceptional digital experiences.
                        </p>
                    </div>
                </div>
            </section>
            <TechPartnerSection />
            {/* <IndustriesShowcaseSlider /> */}
            <WhyChooseMobikode />
            <OurServicesSection />
            <OurValuesSection />
            <ContactSection />
            <OurIndustriesSection />
            <OurProductsSection />
            <OurAchievementsSection />
            <EngagementModal />
            <CareerCTASection />
        </div>
    )
}

export default Transforming
